

import { Button, Card, Checkbox, Col, Form, Row } from 'antd';
import { Link } from 'react-router-dom';
import PageHeading from '../../../../../components/common/PageHeading'
import { Upload, message } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import EmailPreviewForm from './EmailPreviewForm';
import FormAction from "../../../../../components/common/FormAction";
import { Alert, Space } from 'antd';
import { useState } from 'react';
import Footer from '../../../../../components/common/Footer';

const { Dragger } = Upload;


const AutomaticCommunicationSettings = () => {


  const [showSecondCheckbox, setShowSecondCheckbox] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const handleFirstCheckboxChange = (event) => {
    setShowSecondCheckbox(event.target.checked);
  };

  const handleSecondCheckboxChange = (event) => {
    setShowButton(event.target.checked);
  };
  const GeneralSettingsRightBar = [];


  return (<>
    <div className="page-container">
      <div className="main-container">
        <PageHeading heading="Automatic Communication Settings" />

        <Form >

          <Row >

            <Col span={24}>
              <Checkbox>
                <p style={{ margin: '10px 0px 10px 10px' }}> Send automatic birthday emails to tenants</p>
              </Checkbox>

              <p style={{ marginLeft: '60px' }}>Birthday emails will be sent to current, financially responsible tenants on their birthday.

              </p>
            </Col>


            <Col span={24} style={{ margin: '10px 0px' }}>

              <label style={{ margin: '10px 0px 10px -18px' }}>
                <input
                  type="checkbox"
                  onChange={handleFirstCheckboxChange}
                  style={{ margin: '0px 20px' }}
                />
                Send automatic birthday emails to tenants
              </label>
              {/* <Col span={24}>
                <Space
                  direction="vertical"
                  style={{
                    width: '100%',
                    margin: '10px 0px'
                  }}
                >

                  <Alert message="Automatically send a quick questionnaire to capture key prospect information and ensure a good fit. 
                  <a href='#'>Learn More</a>" type="success" showIcon icon={<InfoCircleOutlined />} />

                </Space>
              </Col> */}

              <Col span={22} style={{ marginLeft: '50px' }}>
                {showSecondCheckbox && (
                  <label style={{ margin: '10px 0px 10px -10px' }}>
                    <input type="checkbox"
                      onChange={handleSecondCheckboxChange}
                      style={{ margin: '0px 10px' }} />
                    Include link to pre-qualification questions.
                  </label>
                )}
                <h4>Email Preview</h4>
                <Col>
                  <EmailPreviewForm showButton={showButton} />
                </Col>
              </Col>

            </Col>

            <Col span={24} style={{ margin: '10px 0px' }}>
              <Checkbox>
                <p style={{ margin: '10px 0px 10px 10px' }}> Automatically send a confirmation email when rental applications are completed</p>
              </Checkbox>

              <p style={{ marginLeft: '60px' }}>The automated email will include shareable link that additional housemates or cosigners can use. Applications submitted via this link will be grouped. <a>
                Learn More.</a>

              </p>
            </Col>

            <Col span={24} style={{ margin: '10px 0px' }}>
              <Checkbox>
                <p style={{ margin: '10px 0px 10px 10px' }}> Send automatic emails or texts for Work Order status updates</p>
              </Checkbox>

              <p style={{ marginLeft: '60px' }}>Status updates will be emailed or texted to residents for the following:
                <br></br>
                <ul style={{ listStyleType: 'circle' }}>
                  <li><b>New</b> (only when submitted through the online portal)</li>
                  <li><b>Scheduled</b> (including when date and/or time changes)</li>
                  <li><b>Waiting</b> (only when notes are included)</li>
                  <li><b>Completed</b></li>
                  <li><b>Canceled</b></li>
                  <li><b>Scheduled Maintenance Reminders </b>(text tenants the day before scheduled maintenance)</li>
                </ul>
              </p>
            </Col>


            <Col span={24} style={{ margin: '10px 0px' }}>
              <Checkbox>
                <p style={{ margin: '10px 0px 10px 10px' }}>  Send automatic emails to guest cards after showings.</p>
              </Checkbox>

              <p style={{ marginLeft: '60px' }}>Emails with a link to the rental application will be sent to guest cards 24 hours after their showings. Your company must have <a href="/generalsettings/online-posting-settings">online applications enabled </a> for website and internet listings.
              </p>
            </Col>
          </Row>

          <Row>
            <Col span={24} style={{
              margin: '10px 0px 0px 0px'
            }}>
              <FormAction />
            </Col>
          </Row>


        </Form>
        <Footer />
      </div>
    </div>
    <div className="RightSidebar">
                <RightBar RightBarData={GeneralSettingsRightBar} />
            </div>

  </>
  )
}
export default AutomaticCommunicationSettings;
